module.exports = __webpack_public_path__ + "img/call-btn.f69698d7.svg";